import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const FirstLevelRow: React.FC = () => (
  <Box display="flex" alignItems="center" justifyContent="space-between" mb="12">
    <Shimmer width={120} height={24} />
    <Shimmer width={120} height={24} />
  </Box>
);

const SecondLevelRow: React.FC = () => (
  <Box display="flex" alignItems="center" justifyContent="space-between" pl="12" mb="12">
    <Shimmer width={100} height={24} />
    <Shimmer width={80} height={24} />
  </Box>
);

export const LabeledListLoading: React.FC = () => {
  return (
    <Box>
      <FirstLevelRow />

      {times(4).map(i => (
        <SecondLevelRow key={i} />
      ))}

      {times(3).map(i => (
        <FirstLevelRow key={i} />
      ))}
    </Box>
  );
};
